<template>
    <div class="flex flex-col">
        <div class="flex items-center justify-between p-12">
            <div class="">
                <div class="mb-8 text-xl font-light">
                    First, let's see if there's a drain you can adopt.
                </div>

                <label for="gmap-autocomplete" class="block mb-8 font-bold">
                    Enter your address to select a drain.
                </label>

                <autocomplete @placeChanged="({center}) => this.center = center"></autocomplete>
            </div>
        </div>

        <div class="w-full">
            <map-drain
                :adopted-drain-ids="adoptedDrainIds"
                :height="430"
                :initial-center="center"
                :my-drain-ids="myDrainIds"
                :selected-drain="selectedDrain"
                :user="user"
                v-on:update:center="updateMapCenterListener"
                v-on:update:zoom="updateMapZoomListener"
            />
        </div>

        <div
            class="w-full p-4 text-center"
            style="background: rgb(194, 221, 221);"
            v-if="suggestedDrainsEnabled"
        >
            <p class="text-lg font-semibold leading-relaxed">
                Don't see your drain? <br />
            </p>
            <p class="mt-1 text-lg leading-relaxed">
                <a
                    :href="suggestDrainUrl"
                    class="mt-4 font-bold no-underline text-teal-darker"
                    >Add one here.</a
                >
            </p>
        </div>
    </div>
</template>

<script>
import MapDrain from './MapDrain';
import Autocomplete from './Autocomplete';

export default {
    components: { MapDrain, Autocomplete },

    props: {
        adoptedDrainIds: { default: null },
        initialCenter: {},
        myDrainIds: { default: null },
        selectedDrain: { default: null },
        user: { default: null },
        suggestedDrainsEnabled: { default: false },
    },

    data() {
        return {
            center: this.initialCenter,
            mapCenter: {},
            mapZoom: 17,
        };
    },

    computed: {
        suggestDrainUrl: function() {
            return (
                'suggested-drains/create?' +
                new URLSearchParams({
                    zoom: this.mapZoom,
                    lat: this.mapCenter.lat,
                    lng: this.mapCenter.lng,
                }).toString()
            );
        },
    },

    methods: {
        setPlace(place) {
            this.center = place.geometry.location;
        },
        updateMapCenterListener: function(data) {
            this.mapCenter = data;
        },
        updateMapZoomListener: function(data) {
            this.mapZoom = data;
        },
    },
};
</script>
